const modifiedFields = ['metricName', 'targetFilter', 'metricDescription', 'searchOptions'];
const modifiedFieldCustom = {};
export default { modifiedFields, modifiedFieldCustom };
